import React, { useState, useEffect } from 'react';
import { DashboardLayout, companyMenuItems } from '../../components/DashboardLayout';
import { solicitationsAPI } from '../../lib/api';
import { Card, CardContent } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { 
  Clock, 
  CheckCircle2, 
  XCircle,
  Loader2,
  FileText,
  Calendar
} from 'lucide-react';
import { toast } from 'sonner';

export default function CompanySolicitations() {
  const [solicitations, setSolicitations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSolicitations();
  }, []);

  const fetchSolicitations = async () => {
    try {
      const response = await solicitationsAPI.getSent();
      setSolicitations(response.data);
    } catch (error) {
      toast.error('Erro ao carregar solicitações');
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'PENDING':
        return <Badge className="bg-amber-100 text-amber-700"><Clock className="w-3 h-3 mr-1" />Pendente</Badge>;
      case 'APPROVED':
        return <Badge className="bg-emerald-100 text-emerald-700"><CheckCircle2 className="w-3 h-3 mr-1" />Aprovado</Badge>;
      case 'REJECTED':
        return <Badge className="bg-red-100 text-red-700"><XCircle className="w-3 h-3 mr-1" />Rejeitado</Badge>;
      default:
        return <Badge variant="outline">{status}</Badge>;
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleDateString('pt-BR');
  };

  return (
    <DashboardLayout menuItems={companyMenuItems}>
      <div className="space-y-6" data-testid="company-solicitations">
        {/* Header */}
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Solicitações Enviadas</h1>
          <p className="text-slate-600">Acompanhe suas solicitações de acesso</p>
        </div>

        {/* Solicitations List */}
        {loading ? (
          <div className="flex items-center justify-center py-20">
            <Loader2 className="w-8 h-8 animate-spin text-cyan-600" />
          </div>
        ) : solicitations.length === 0 ? (
          <Card className="border-slate-200">
            <CardContent className="py-16 text-center">
              <FileText className="w-12 h-12 text-slate-300 mx-auto mb-4" />
              <h3 className="text-lg font-medium text-slate-900 mb-2">
                Nenhuma solicitação enviada
              </h3>
              <p className="text-slate-600">
                Busque candidatos e solicite acesso aos dados
              </p>
            </CardContent>
          </Card>
        ) : (
          <div className="space-y-4">
            {solicitations.map((solicitation) => (
              <Card 
                key={solicitation.id} 
                className="border-slate-200"
                data-testid={`solicitation-item-${solicitation.id}`}
              >
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div>
                      <div className="flex items-center gap-2 mb-2">
                        {getStatusBadge(solicitation.status)}
                      </div>
                      <h3 className="text-lg font-semibold text-slate-900 mb-1">
                        {solicitation.candidate_cargo || 'Candidato'}
                      </h3>
                      <div className="flex items-center gap-2 text-sm text-slate-600">
                        <Calendar className="w-4 h-4" />
                        Solicitado em {formatDate(solicitation.created_at)}
                      </div>
                    </div>
                    {solicitation.status === 'APPROVED' && (
                      <Badge className="bg-cyan-100 text-cyan-700">
                        Chat disponível
                      </Badge>
                    )}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
